module.exports = __webpack_public_path__ + "static/media/fr.05b71edc.webp";